import { useApiTestingLanguage } from './useApiTestingLanguage';
/**
 * CredentialCard Component
 * 
 * Displays a single API credential with its type and actions.
 * Extracted from APITesting.js for better maintainability.
 */

import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Edit, Trash2 } from 'lucide-react';

export const CredentialCard = ({
  credential,
  onEdit,
  onDelete
}) => {
  const { t } = useApiTestingLanguage();
  return (
    <Card className="p-6" data-testid={`credential-card-${credential.id}`}>
      <div className="flex justify-between items-center">
        <div>
          <h4 className="text-lg font-semibold text-gray-900">{credential.name}</h4>
          <Badge className="mt-1">
            {credential.type.replace('_', ' ').toUpperCase()}
          </Badge>
        </div>
        <div className="flex space-x-2">
          <Button 
            variant="outline" 
            size="sm"
            aria-label={t("Edit")}
            onClick={() => onEdit(credential)}
            data-testid={`btn-edit-cred-${credential.id}`}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            className="text-red-600"
            aria-label={t("Delete")}
            onClick={() => onDelete(credential)}
            data-testid={`btn-delete-cred-${credential.id}`}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Card>
  );
};
